'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidAttach = function IoAndroidAttach(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.9 10h2.5v18.4c0 5-4.2 9.1-9.3 9.1s-9.1-4.1-9.1-9.1v-19.3c0-3.6 3-6.6 6.6-6.6s6.8 3 6.8 6.6v19.3c0 2.3-1.9 4.1-4.3 4.1s-4.1-1.8-4.1-4.1v-15.9h2.5v15.9c0 0.9 0.7 1.6 1.6 1.6s1.8-0.7 1.8-1.6v-19.3c0-2.3-1.9-4.1-4.3-4.1s-4.1 1.8-4.1 4.1v19.3c0 3.6 3 6.6 6.6 6.6s6.8-3 6.8-6.6v-18.4z' })
        )
    );
};

exports.default = IoAndroidAttach;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-attach.js
// module id = 1819
// module chunks = 0